import { BaseBackgroundDrawer } from './BaseBackgroundDrawer';
import { GameLayers } from '../../../core/enums';
import { resourceHelper } from '../../../core/resourceHelper';
import { sharedSourceNames, webSourceNames } from '../../../core/sourceNames';
import { webConfig } from '../../../core/applicationConfig';
import { translationKeys } from '../../../core/translation/translation';
import { amountTextStyle } from '../../../core/textStyles';
import { popupService } from '../../../services/helperServices/PopupService';
import { BONUS_COST_AMOUNT, GAME_APPLICATION_SCENE_STATE } from '../../../stateManagment';
import { getAmount } from '../../../core/helpers/getAmount';
import { BONUS_COST_MULTIPLIER } from '../../../core/constats';
import { gamePadService } from '../../../services/helperServices/GamePadService';
import { soundService } from '../../../services/helperServices/SoundService';
import { autoSpinHelper } from '../../../services/helperServices/AutoSpinService';

export class BackgroundWebDrawer extends BaseBackgroundDrawer {
  constructor() {
    super();
    this.winOddConfigs = {
      containerPosition: {
        x: webConfig.width / 2,
        y: 360,
      },
      leafMistake: 110,
      textScale: 1,
      leafScale: .4,
      shadowScale: 4,
      oddStart: 350,
      oddEnd: -80,
      winStart: 350,
      winEnd: 10,
      winFontSize: 75,
      oddFontSize: 80,
    };
    this.multiplierConfigs = {
      oddStart: { x: webConfig.width / 2, y: 750 },
      oddEnd: { x: 1800, y: 750 },
      oddFontSize: 80,
      oddScale: 1,
    };
  }

  setBackground() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.background));
    this.container[GameLayers.background].addChild(texture);
  }

  setShadow() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.shadow));
    this.container[GameLayers.shadow].addChild(texture);
  }

  setDragonForceBack() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.tikiBack));
    this.container[GameLayers.dragonForceBack].addChild(texture);
  }

  setDragonForce() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.tiki));
    this.container[GameLayers.dragonForce].addChild(texture);
  }

  setWallAnimationTexture() {
    const texture = this.createSpine(resourceHelper.get(webSourceNames.wallSpine));
    this.setPosition(texture, webConfig.staticAnimationPosition);
    this._setupWallAnimations(texture);
    this.container[GameLayers.wallSpine].addChild(texture);
  }

  setWaterAnimationTexture() {
    super._setBackground({
      name: webSourceNames.waterSpine,
      containerName: GameLayers.waterSpine,
      position: webConfig.staticAnimationPosition,
      startAnimation: false,
    });
  }

  setFishAnimationTexture() {
    this._setFishAnimationTexture({
      name: webSourceNames.fishSpine,
      position: webConfig.staticAnimationPosition,
    });
  }

  setWaterFallAnimationTexture() {
    super._setBackground({
      name: webSourceNames.waterfallSpine,
      containerName: GameLayers.waterfallSpine,
      position: webConfig.staticAnimationPosition,
    });
  }

  setTreesAnimationTexture() {
    super._setBackground({
      name: webSourceNames.treesSpine,
      containerName: GameLayers.treesSpine,
      position: webConfig.staticAnimationPosition,
    });
  }

  setDragonAnimationTexture() {
    const texture = this.createSpine(resourceHelper.get(webSourceNames.dragonSpine));
    this.setPosition(texture, webConfig.staticAnimationPosition);
    this._setupDragonAnimations(texture);
    this.container[GameLayers.dragonSpine].addChild(texture);
  }

  setBreakingBallSpineTexture(position = webConfig.staticAnimationPosition) {
    this._setBreakingBallSpineTexture({
      name: webSourceNames.breakingBallSpine,
      position: position,
    });
  }

  setParticlesTexture(position = webConfig.staticAnimationPosition) {
    this._setParticlesSpineTexture({
      name: webSourceNames.particles,
      position: position,
    });
  }

  setDragonSoulAnimationTexture() {
    this._setDragonSoulAnimationTexture({
      name: webSourceNames.dragonSoulSpine,
      position: webConfig.staticAnimationPosition,
    });
  }

  setWinOdd(res) {
    return super.setWinOdd(res, {
      position: this.winOddConfigs.containerPosition,
      winOddConfigs: this.winOddConfigs,
    });
  }

  setMultiplierAnimation(res) {
    return super.setMultiplierAnimation(res, this.multiplierConfigs);
  }

  setBallBreakWin(odd, turn, length, side, position = {}) {
    return super.setBallBreakWin(
      {
        odd,
        turn,
        length,
        side,
        position: position,
        positionMistake: { y: 170 },
        winOddConfigs: this.winOddConfigs,
      });
  }

  setAllBreakingBallsSpine(position) {
    this._getBreakingBallTexture({
      name: webSourceNames.breakingBallSpine,
      position: position,
    }, webConfig);
  }

  setUserIdDeposit() {
    const container = this.getUserIdAndDeposit({
      icon: this.createSprite(resourceHelper.get(sharedSourceNames.depositIcon)),
      // freeBetIcon: this.createSprite(this.resources[backgroundResourceNames.freeBetButtonIcon]),
    });
    this.setPosition(container, { x: webConfig.width - 40 - container.size, y: 40 });
    this.container[GameLayers.deposit].addChild(container);
  }

  setBuyBonusButton() {
    const container = this.createContainer('container');
    const buttonTexture = this.createSprite(resourceHelper.get(webSourceNames.buyBonusButton));
    const titleTexture = this.createText(translationKeys.buyBonus, {
      ...amountTextStyle,
      fontSize: 33,
      fontWeight: 900,
    });

    const valuesTexture = this.createText(getAmount(BONUS_COST_AMOUNT.getValue()), {
      ...amountTextStyle,
      fontSize: 33,
      fontWeight: 900,
    });

    this.addSubscriber(gamePadService.subscribeQuickBet(state => {
      BONUS_COST_AMOUNT.next(state * BONUS_COST_MULTIPLIER);
      valuesTexture.text = getAmount(BONUS_COST_AMOUNT.getValue());
    }));

    this.addSubscriber(GAME_APPLICATION_SCENE_STATE.subscribe((value) => {
      if (value === 'bonus') {
        buttonTexture.visible = false;
        valuesTexture.visible = false;
        titleTexture.visible = false;
        this.setupButtonMode(buttonTexture, { interactive: false, buttonMode: false });
      } else {
        buttonTexture.visible = true;
        valuesTexture.visible = true;
        titleTexture.visible = true;
        this.setupButtonMode(buttonTexture, { interactive: true, buttonMode: true });
      }
    }, true));

    titleTexture.anchor.set(.5);
    valuesTexture.anchor.set(.5);
    buttonTexture.anchor.set(.5);
    buttonTexture.scale.set(1);
    this.setPosition(container, { x: webConfig.width / 2, y: 250 });
    this.setPosition(titleTexture, { x: 0, y: 5 });
    this.setPosition(valuesTexture, { x: 0, y: 35 });
    container.addChild(
      buttonTexture,
      titleTexture,
      valuesTexture,
    );
    this.setupButtonMode(buttonTexture);
    this.registerClick(buttonTexture, () => {
      if (gamePadService.autoSpinActiveState) {
        autoSpinHelper.end();
        gamePadService.enableAll();
      }
      soundService.playSingleClick();
      popupService.openBuyBonusPopup();
    });
    this.container[GameLayers.buyBonusButton].addChild(container);
  }

  setStaticAnimations() {
    this.setWallAnimationTexture();
    this.setWaterAnimationTexture();
    this.setFishAnimationTexture();
    this.setWaterFallAnimationTexture();
    this.setTreesAnimationTexture();
    this.setDragonAnimationTexture();
    this.setBreakingBallSpineTexture();
    this.setParticlesTexture();
    this.setDragonSoulAnimationTexture();
    this.setBuyBonusButton();
    this.setUserIdDeposit();
  }
}
